module.exports = "/assets/data/3121a90b1ec6cd1f617e09b67d2cddd1-WN5.data.json";